import { AxiosRequestConfig, AxiosResponse, Method } from "axios";
import axiosInstance from "./axios";

// function updateCsrfToken() {
//     const token = getCookie('csrftoken');
//     if (token) {
//         axiosInstance.defaults.headers.common['X-CSRFTOKEN'] = token;
//         csrfToken = token;
//     }
// }

// function api<T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {
//   return axiosInstance.request(config); //.finally(updateCsrfToken);
// }

const BACKEND_URL = import.meta.env.VITE_API_URL || "";

interface AxiosRequestConfigPatch extends Omit<AxiosRequestConfig, "method"> {
  method?: Method;
}

export function backendApi<T>(
  config: AxiosRequestConfigPatch
): Promise<AxiosResponse<T>> {
  return axiosInstance.request({ baseURL: BACKEND_URL, ...config }); //.finally(updateCsrfToken);
}
